import React from 'react';

const SBPSvg = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M18.541 8.34375L12.584 11.9922L12.5898 11.9961L12.5771 12.0029L12.6572 12.0527L18.541 15.6582L11.4102 20.0264V12.7178L5.45898 16.3643V7.62695L11.4102 11.2725V3.97363L18.541 8.34375ZM12.7109 17.7041L16.0527 15.6572L12.7109 13.6094V17.7041ZM6.75977 14.042L10.1016 11.9951L6.75977 9.94727V14.042ZM12.7109 10.3896L16.0527 8.34277L12.7109 6.29492V10.3896Z" fill="white" fill-opacity="0.6"/>
  </svg>
);

export default SBPSvg;